<template>
  <section v-show="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>{{ saleDetailsText.header.title }}</h4>
      <p>{{ saleDetailsText.header.description }}</p>
    </header>

    <div class="app-modal__grid two-columns">
      <label class="app-modal-field full-width">
        <span>{{ saleDetailsText.fields.scope }}</span>
        <textarea
          v-model.trim="form.scope"
          class="form-control app-modal-field__textarea"
          rows="3"
          :placeholder="saleDetailsText.placeholders.scope"
        ></textarea>
      </label>

      <label class="app-modal-field full-width">
        <span>{{ saleDetailsText.fields.comments }}</span>
        <textarea
          v-model.trim="form.comments"
          class="form-control app-modal-field__textarea"
          rows="4"
          :placeholder="saleDetailsText.placeholders.comments"
        ></textarea>
      </label>
    </div>
  </section>
</template>

<script>
import { SALES_TEXT } from '@/texts/catalog/sales';

const SALE_DETAILS_TEXT = SALES_TEXT.modal.content.details;

export default {
  name: 'SaleModalSectionDetails',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    saleDetailsText() {
      return SALE_DETAILS_TEXT;
    },
  },
};
</script>
